// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_modalOverlay__xesCe {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.Modal_modal__SKeRL {
  background: var(--white-color);
  padding: 24px;
  border-radius: 8px;
  position: relative;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
  animation: Modal_fadeIn__dh-uH 0.3s ease-in-out;
}

.Modal_modalContent__Bns4u {
  margin-top: 10px;
  font-size: 16px;
  color: #333;
}

.Modal_modalActions__EOVSt {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 10px;
}

.Modal_confirmBtn__CeSZv {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 5px;
  cursor: pointer;
}

.Modal_cancelBtn__ZqoVP {
  background-color: #e0e0e0;
  color: #333;
  border: none;
  padding: 8px 14px;
  border-radius: 5px;
  cursor: pointer;
}

.Modal_confirmBtn__CeSZv:hover {
  background-color: #0056b3;
}

.Modal_cancelBtn__ZqoVP:hover {
  background-color: #cfcfcf;
}

.Modal_closeButton__gCJBe {
  background: #ffffff;
  border: none;
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
  color: #555;
  position: absolute;
  top: -10px;
  right: -10px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

@keyframes Modal_fadeIn__dh-uH {
  from {
    opacity: 0;
    transform: translateY(-10%);
  }
  to {
    opacity: 1;
    transform: translateY(0%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/NewCreateAppF/Modal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,+CAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,yBAAyB;EAC3B;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.45);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: var(--white-color);\n  padding: 24px;\n  border-radius: 8px;\n  position: relative;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.modalContent {\n  margin-top: 10px;\n  font-size: 16px;\n  color: #333;\n}\n\n.modalActions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n  gap: 10px;\n}\n\n.confirmBtn {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.cancelBtn {\n  background-color: #e0e0e0;\n  color: #333;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.confirmBtn:hover {\n  background-color: #0056b3;\n}\n\n.cancelBtn:hover {\n  background-color: #cfcfcf;\n}\n\n.closeButton {\n  background: #ffffff;\n  border: none;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  color: #555;\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10%);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `Modal_modalOverlay__xesCe`,
	"modal": `Modal_modal__SKeRL`,
	"fadeIn": `Modal_fadeIn__dh-uH`,
	"modalContent": `Modal_modalContent__Bns4u`,
	"modalActions": `Modal_modalActions__EOVSt`,
	"confirmBtn": `Modal_confirmBtn__CeSZv`,
	"cancelBtn": `Modal_cancelBtn__ZqoVP`,
	"closeButton": `Modal_closeButton__gCJBe`
};
export default ___CSS_LOADER_EXPORT___;
